// 这是一个用来配置pageview事件的配置表
// 只能配置router定义过的path，router.tsx
export const Event = {
  Web3PageView: 'Web3PageView',
  Web3UserClick: 'Web3UserClick',
};

export const Page = {
  UpcomingPage: 'Web3PointsUpcoming',
  HomePage: 'Web3Points',
  CheckinPopUp: 'Web3Points_CheckInPopUp',
  RewardsPage: 'Web3Points_Rewards',
  CheckInPopUp: 'Web3Points_CheckInPopUp',
};
